import React, { useRef } from "react";
import usePrice from "../../hooks/usePrice";
import useFormat from "../../hooks/useFormat";
import CartRow from "./CartRow";

const LocationCartList = ({ refreshCart, visibleTables, ...cart }) => {
  const { cartPrice } = usePrice({ cart });
  const { formatPrice } = useFormat();
  const tableRef = useRef(null);

  return (
    <>
      {/* Table Container with Scroll Animation */}
      <div
        ref={tableRef}
        className="table-container"
        style={{
          overflow: "hidden",
          transition: "height 0.3s ease-in-out",
          height: visibleTables[cart.id] ? "auto" : "0",
        }}
      >
        {/* Table for Desktop */}
        <div >
          <div className="cart-table border border-gray-100 rounded-8">
            <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
              <table className="table rounded-8 overflow-hidden">
                <thead>
                  <tr className="border-bottom border-neutral-100">
                    {/* <th className='h6 mb-0 text-lg fw-bold px-40 py-32 border-end border-neutral-100'>
                                            <input
                                                type='checkbox'
                                                checked={checkedAll}
                                                onChange={handleCheckAll}
                                            />
                                        </th> */}
                    <th className="text-start h6 text-lg fw-bold px-20 py-16 border-end border-neutral-100">
                      Image
                    </th>
                    <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                      Product Name
                    </th>
                    <th className="text-start h6 text-lg fw-bold px-20 py-16 border-end border-neutral-100">
                      Quantity
                    </th>
                    <th className="text-start h6 text-lg fw-bold px-20 py-16 border-end border-neutral-100">
                      Price
                    </th>
                    <th className="text-start h6 text-lg fw-bold px-20 py-16 border-end border-neutral-100">
                      Total
                    </th>
                    <th className="text-start h6 text-lg fw-bold px-20 py-16 border-end border-neutral-100"></th>
                  </tr>
                </thead>
                <tbody>
                    {cart?.lines &&
                    cart?.lines.map((item, index) => (
                        <CartRow
                            refreshCart={refreshCart}
                            index={index}
                            cartId={cart?.id}
                            {...item}                       
                            
                        />
                    ))}

                  {/* TOTAL ROW - CONNECTED TO TABLE */}
                  <tr className="bg-light">
                    <td
                      colSpan="4"
                      className="left text-end px-20 py-16 text-2xl fw-semibold border-top border-neutral-200"
                    >
                      Subtotal
                    </td>
                    <td className="px-20 py-16 text-xl fw-semibold border-top border-neutral-200">
                      {formatPrice(cartPrice.totalPrice)}
                    </td>
                    <td className="border-top border-neutral-200"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Card Layout for Mobile */}
        {/* <div className='d-block d-lg-none'>
                    {cart?.lines &&
                        cart?.lines.map((item, index) => (     
                            <div key={item.id} className='card mb-16'>
                                <div className='card-body'>
                                    <div className='d-flex justify-content-between align-items-center mb-16'>
                                        <input
                                            type='checkbox'
                                            checked={checkedItems[item.id] || false}
                                            onChange={handleCheckboxChange(item.id)}
                                        />
                                        <img
                                            src={item.image}
                                            alt=''
                                            className='rounded-8'
                                            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                        />
                                    </div>
                                    <h6 className='text-lg fw-semibold mb-8'>
                                        <Link to='/product-details' className='link'>
                                            {item.name}
                                        </Link>
                                    </h6>
                                    <div className='d-flex align-items-center gap-16 mb-16'>
                                        <button
                                            className='ph ph-minus w-52 h-52 bg-main-50 text-main-600 text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle'
                                            onClick={() => handleDecrement(item.id)}
                                        >
                                            -
                                        </button>
                                        <span className='text-lg h6 mb-0 fw-semibold'>{item.quantity}</span>
                                        <button
                                            className='ph ph-plus w-52 h-52 bg-main-50 text-main-600 text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle'
                                            onClick={() => handleIncrement(item.id)}
                                        >
                                            +
                                        </button>
                                    </div>
                                    <div className='mb-16'>
                                        <span className='text-lg h6 mb-0 fw-semibold' style={{ color: '#8fbb27' }}>
                                            {item.price}
                                        </span>
                                        <br />
                                        <span className='text-lg h6 mb-0 fw-semibold'>
                                            <del>{item.originalPrice}</del>
                                        </span>
                                    </div>
                                    <div className='text-center'>
                                        <a
                                            className='w-52 h-52 bg-main-50 text-main-600 text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle'
                                            href='/product-details'
                                        >
                                            <i className='ph ph-trash'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div> */}
      </div>
    </>
  );
};

export default LocationCartList;
